(() => {
  const bindCookieSettings = (scope = document) => {
    scope.querySelectorAll('[data-sc-cookie-settings]').forEach((button) => {
      if (button.dataset.scCookieReady === 'true') return;
      button.dataset.scCookieReady = 'true';

      button.addEventListener('click', () => {
        const showPreferences = window.Shopify?.customerPrivacy?.showPreferences;
        if (typeof showPreferences === 'function') showPreferences();
      });
    });
  };

  bindCookieSettings();
  document.addEventListener('shopify:section:load', (event) => bindCookieSettings(event.target));
})();
